$(document).ready(function()
{
    
    function fullCart()
    {
        var currentCartItems = {};

        var currentCartPrice = 0.00;
        var totalDeliveryCost = 0.00;
        var finalTotalCosts = 0.00;

        var maxEclecticDeliveryCost = parseFloat($('#eclecticMaxDelivery').html());
        var maxEpionceDeliveryCost = parseFloat($('#epionceMaxDelivery').html());

        var hasSplitDelivery = false;
        var hasEpionceDelivery = false;
        var hasEclecticDelivery = false;

        var eclecticDeliveryCost = 0.00;
        var epionceDeliveryCost = 0.00;

        updateFullCart();

        function updateFullCart()
        {

            currentCartItems = localStorage.getItem('currentCartItems');

            if (currentCartItems)
            {
                currentCartItems =  JSON.parse(currentCartItems);
            }
            else
            {
                currentCartItems = {};
            }

            var echoString = '';

            currentCartPrice = 0.00;
            eclecticDeliveryCost = 0.00;
            epionceDeliveryCost = 0.00;
            totalDeliveryCost = 0.00;
            finalTotalCosts = 0.00;
            hasSplitDelivery = false;
            hasEpionceDelivery = false;
            hasEclecticDelivery = false;
            totalUnits = 0;

            var lines = 0;

            for (var key in currentCartItems)
            {
                var line = currentCartItems[key];
                
                if (line.is_epionce && line.is_epionce != 0) 
                {
                  updateEpionceDeliveryCharge();
                }
                else
                {
                  updateEclecticDeliveryCharge(line.delivery_charge, line.qty);
                }

                var line_subtotal = parseFloat(line.final_price * line.qty); 
                totalUnits += line.qty;

                //var bin_it = '<i class="fa fa-trash cart-item-remove" aria-hidden="true" data-remove="' + key + '"></i>';
                //var minus_it = '<i class="fa fa-minus cart-item-minusadj" aria-hidden="true" data-minusadj="' + key + '"></i>';
                //var plus_it = '<i class="fa fa-plus cart-item-plusadj" aria-hidden="true" data-plusadj="' + key + '"></i>';

                var bin_it = '<button class="custom-icon remove cart-item-remove"  data-remove="' + key + '" title="Remove Product"><span class="show-for-sr">Remove Product</span></button>';
                var minus_it = '<button class="custom-icon minus cart-item-minusadj"  data-minusadj="' + key + '" title="Reduce quantity by one"><span class="show-for-sr">Reduce quantity by one</span></button>';
                var plus_it = '<button class="custom-icon plus cart-item-plusadj"  data-plusadj="' + key + '" title="Increase quantity by one"><span class="show-for-sr">Increase quantity by one</span></button>';
              
                echoString += "\n" + '<tr>';
                echoString += "\n\t" + '<td class="toggle-icons">' + plus_it + minus_it + bin_it + "</td>";
                echoString += "\n\t" + '<td><a href="' + line.product_link  + '">' + line.title + "</a></td>";

                if (parseFloat(line.final_price) == parseFloat(line.full_price))
                {
                    echoString += "\n\t" + '<td class="subtotal">' + SharedUtils.currencyFormat(line.final_price) + "</td>";
                }
                else
                {
                    echoString += "\n\t" + '<td class="subtotal"><p class="full-price-small">' + SharedUtils.currencyFormat(line.full_price) + '</p>' + SharedUtils.currencyFormat(line.final_price) + "</td>";
                }

                echoString += "\n\t" + '<td class="subtotal">' + line.qty + "</td>";
                echoString += "\n\t" + '<td class="subtotal">' + SharedUtils.currencyFormat( line_subtotal ) + "</td>";
                echoString += "\n" + '</tr>';

                currentCartPrice += line_subtotal;

                lines++;

            }

            
            finalTotalCosts = currentCartPrice + totalDeliveryCost;

            $("#cartOutputItems").html(echoString);
            $("#cartFinalPrice").html(SharedUtils.currencyFormat(currentCartPrice));
            $("#finalDeliveryCharge").html(SharedUtils.currencyFormat(totalDeliveryCost));
            $("#totalFinalPrice").html(SharedUtils.currencyFormat(finalTotalCosts));

            if (finalTotalCosts > SharedConfig.maximumBasketValue || totalUnits > SharedConfig.maximumBasketUnits )
            {
                $('#showTheCart').slideDown();
                $('#hideTheCart').slideUp();
                var warningMsg = '';
                if (finalTotalCosts > SharedConfig.maximumBasketValue)
                {
                    warningMsg = "The maximum value permitted for a transaction is " + SharedUtils.maxBasketValueStr() + ". Please remove some items.";
                }
                else
                {
                    warningMsg = "The maximum number of products you can purchase in a single transaction is " + SharedConfig.maximumBasketUnits + ". Please remove some items.";
                }

                $('#maxValuesWarning .warningMsg').html(warningMsg);
                $('#maxValuesWarning').slideDown();
                $('#checkoutButton').addClass('disabled-btn');
            }
            else if(lines == 0)
            {
              $('#hideTheCart').slideDown();
              $('#showTheCart').slideUp();
              $('#maxValuesWarning').slideUp();
              $('#checkoutButton').removeClass('disabled-btn');
            }
            else
            {
              $('#hideTheCart').slideUp();
              $('#showTheCart').slideDown();    
              $('#maxValuesWarning').slideUp();   
              $('#checkoutButton').removeClass('disabled-btn');       
            }

        }

        $(document).on("click", ".cart-item-remove" , function() 
        {
            var removeSku = $(this).data('remove');
            removeFromFullCart(removeSku);
        });


        $(document).on("click", ".cart-item-plusadj" , function()
        {
            var adjSku = $(this).data('plusadj');
            adjustFullCartItem(adjSku, 1);
        });

        $(document).on("click", ".cart-item-minusadj" , function()
        {
            var adjSku = $(this).data('minusadj');
            adjustFullCartItem(adjSku, -1);
        });


        function updateEpionceDeliveryCharge()
        {
          hasEpionceDelivery = true;    
          if (epionceDeliveryCost == 0)
          {
            epionceDeliveryCost = maxEpionceDeliveryCost;
            if (hasEclecticDelivery && hasEpionceDelivery)
            {
              hasSplitDelivery = true;
            }
            else
            {   
                hasSplitDelivery = false;
            }   

          }

          totalDeliveryCost = epionceDeliveryCost + eclecticDeliveryCost;
          //console.log( eclecticDeliveryCost, epionceDeliveryCost, totalDeliveryCost, hasEclecticDelivery, hasEpionceDelivery);
          return true;
        }

        function updateEclecticDeliveryCharge(cost, qty)
        {
          var add_me = parseFloat(cost) * parseInt(qty);
          var new_total = eclecticDeliveryCost + add_me;
          hasEclecticDelivery = true;

          if (new_total > maxEclecticDeliveryCost)
          {
            eclecticDeliveryCost = maxEclecticDeliveryCost;
          }
          else
          {
            eclecticDeliveryCost = new_total;
          }

          if (hasEclecticDelivery && hasEpionceDelivery)
          {
            hasSplitDelivery = true;
          }
            else
            {   
                hasSplitDelivery = false;
            }   

          totalDeliveryCost = epionceDeliveryCost + eclecticDeliveryCost;

          //console.log(cost, qty, add_me, new_total, eclecticDeliveryCost, epionceDeliveryCost, totalDeliveryCost, hasEclecticDelivery, hasEpionceDelivery);

          return true;
        }



        function adjustFullCartItem(sku, amt)
        {
            if (sku in currentCartItems)
            {

                var tmp_count = currentCartItems[sku].qty;
                tmp_count = tmp_count + amt;
                // if we get to 0, remove completely
                if (tmp_count < 1)
                {
                   removeFromFullCart(sku);
                }

                else
                {
                    if (tmp_count > 10) // we don't want more than 10 of anything (for now anyway)
                    {
                        tmp_count = 10;
                    }
                    currentCartItems[sku].qty = tmp_count;
                    localStorage.setItem('currentCartItems', JSON.stringify(currentCartItems));
                    setTimeout(function() 
                    {
                        updateFullCart();
                    }, 100);

                }
            }
        }

        function removeFromFullCart(sku)
        {
            delete currentCartItems[sku];
            localStorage.setItem('currentCartItems', JSON.stringify(currentCartItems));
            setTimeout(function() 
            {
                updateFullCart();
            }, 100);
        }

    };

    if ( $('#fullCart').length )
    {
        fullCart();
    }


});